import produce from "immer";
import {
  GET_USERS_SUCCESS,
  USER_FORM_DELETE_SUCCESS,
  UPDATE_ACCOUNT_SETTING_FORM_SUCCESS,
  UPDATE_USER_EDEC_INTEGRATION_SUCCESS,
  CHECK_LOGIN_FAILED,
  CHECK_LOGIN_SUCCESS,
  CLOSE_LOGIN,
  DISCONNECT_USER,
  LOGIN_ATTEMPT_NOT_VERIFIED,
  LOGIN_FORM_FAILED,
  LOGIN_FORM_SEND,
  LOGIN_FORM_SUCCESS,
  LOGIN_SAML,
  OPEN_LOGIN,
  RESENT_VALIDATION_SUCCESS,
  RESET_LOGIN_ATTEMPT,
  defaultCalculsColumns,
  UPDATE_CALCULS_COLUMNS_SUCCESS,
  ENABLE_USER_LOADER,
  DISABLE_USER_LOADER,
  RESET_LOGIN_ERROR,
} from "../constants";

const initialState = {
  isAuthenticated: false,
  informations: {
    name: "",
    email: "",
    token: "",
    calculsColumns: [],
  },
  loginAttempt: {
    email: "",
    isVerified: true,
  },
  users: [],
  loginModalIsOpen: false,
  error: null,
  loginAttempts: null,
  loginErrorCode: null,
  integrations: {
    edec: {
      username: "",
      password: "",
    },
  },
  isUnlogging: false,
  isLoading: false,
};

const userReducer = produce((draft = initialState, action) => {
  switch (action.type) {
    case DISCONNECT_USER:
      draft.isAuthenticated = false;
      draft.informations = {};
      draft.isUnlogging = true;
      draft.loginAttempts = null;
      draft.loginErrorCode = null;
      break;
    case OPEN_LOGIN:
      draft.loginModalIsOpen = true;
      draft.isUnlogging = false;
      break;
    case CLOSE_LOGIN:
      draft.error = null;
      draft.loginModalIsOpen = false;
      draft.loginAttempts = null;
      draft.loginErrorCode = null;
      break;
    case GET_USERS_SUCCESS:
      formatUsersResponse(draft, action.payload);
      break;
    case USER_FORM_DELETE_SUCCESS:
      removeUser(draft, action.payload);
      break;
    case UPDATE_ACCOUNT_SETTING_FORM_SUCCESS:
      updateUserInformations(draft, action.payload);
      break;
    case LOGIN_FORM_SEND:
      draft.error = null;
      draft.loginAttempts = null;
      draft.loginErrorCode = null;
      break;
    case LOGIN_SAML:
      draft.error = null;
      draft.loginAttempts = null;
      draft.loginErrorCode = null;
      break;
    case LOGIN_FORM_SUCCESS:
      const { accessToken, user } = action.payload;
      draft.informations = {
        ...user,
        id: user._id,
        token: accessToken,
        calculsColumns: user.calculsColumns || defaultCalculsColumns,
      };
      draft.isAuthenticated = true;
      draft.error = null;
      draft.loginAttempts = null;
      draft.loginErrorCode = null;
      break;
    case LOGIN_FORM_FAILED:
      draft.error = action.error;
      draft.loginAttempts = action.loginAttempts ?? null;
      draft.loginErrorCode = action.loginErrorCode ?? null;
      break;
    case LOGIN_ATTEMPT_NOT_VERIFIED:
      draft.loginAttempt.email = action.email;
      draft.loginAttempt.isVerified = false;
      break;
    case RESENT_VALIDATION_SUCCESS:
      draft.loginAttempt.email = "";
      draft.loginAttempt.isVerified = false;
      break;
    case RESET_LOGIN_ATTEMPT:
      if (draft.loginAttempt) {
        draft.loginAttempt.email = "";
        draft.loginAttempt.isVerified = true;
      }
      draft.loginAttempts = null;
      draft.loginErrorCode = null;
      break;
    case CHECK_LOGIN_SUCCESS:
      draft.error = null;
      draft.isAuthenticated = true;
      draft.loginAttempts = null;
      draft.loginErrorCode = null;
      draft.informations = {
        ...action.payload,
        id: action.payload._id,
        calculsColumns: action.payload.calculsColumns || defaultCalculsColumns,
      };
      break;
    case CHECK_LOGIN_FAILED:
      draft.isAuthenticated = false;
      draft.loginAttempts = null;
      draft.loginErrorCode = null;
      draft.informations = {
        name: "",
        email: "",
        token: "",
        calculsColumns: defaultCalculsColumns,
      };
      break;
    case UPDATE_USER_EDEC_INTEGRATION_SUCCESS:
      patchUserEDECIntegration(draft, action.payload);
      break;
    case UPDATE_CALCULS_COLUMNS_SUCCESS:
      draft.informations.calculsColumns = action.payload.calculsColumns;
      break;
    case ENABLE_USER_LOADER:
      draft.isLoading = true;
      break;
    case DISABLE_USER_LOADER:
      draft.isLoading = false;
      break;
    case RESET_LOGIN_ERROR:
      draft.loginAttempts = null;
      draft.loginErrorCode = null;
      draft.error = null;
      break;
    default:
      return draft;
  }
});

function updateUserInformations(draft, payload) {
  draft.informations = {
    ...draft.informations,
    firstName: payload.firstName,
    lastName: payload.lastName,
    type: payload.type,
  };
}

function patchUserEDECIntegration(draft, payload) {
  draft.informations = {
    ...draft.informations,
    integrations: {
      edec: payload.integrations.edec,
    },
  };
}

function removeUser(draft, payload) {
  draft.users.splice(
    draft.users.findIndex((user) => user.id === payload),
    1,
  );
}

function formatUsersResponse(draft, payload) {
  if (payload && payload.data && payload.data.length > 0) {
    draft.users = payload.data.map((user) => ({
      ...user,
      id: user._id,
    }));
  }
}
export default userReducer;
